import React from 'react';
import PropTypes from 'prop-types';

import { formatDateForAgo } from '../../../../helpers/date-time';
import Tile from '../../../../component-library/tile';

const Update = ({
	update,
}) => (
	<div className="margin-bottom-16">
		<Tile>
			<div className="margin-bottom-16 large-text">{update.message}</div>
			<div className="grey-text">{formatDateForAgo(update.timestamp)}</div>
		</Tile>
	</div>
);

export default Update;

Update.propTypes = {
	update: PropTypes.shape({
		message: PropTypes.string,
		timestamp: PropTypes.number.isRequired,
	}).isRequired,
};
